var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronUpBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.9202L7.10314 15.6654C6.87294 15.8885 6.57997 16 6.22422 16C5.86846 16 5.57549 15.8885 5.34529 15.6654C5.1151 15.4423 5 15.1584 5 14.8137C5 14.4689 5.1151 14.185 5.34529 13.962L11.1211 8.36502C11.3722 8.12167 11.6652 8 12 8C12.3348 8 12.6278 8.12167 12.8789 8.36502L18.6547 13.962C18.8849 14.185 19 14.4689 19 14.8137C19 15.1584 18.8849 15.4423 18.6547 15.6654C18.4245 15.8885 18.1315 16 17.7758 16C17.42 16 17.1271 15.8885 16.8969 15.6654L12 10.9202Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUpBlack);
export default __webpack_public_path__ + "static/media/chevron_up_black.90e2a2c5357b79f22c94e9aff8a56cba.svg";
export { ForwardRef as ReactComponent };